import PropTypes from 'prop-types';
import React from 'react';

import { StyledHelperText, StyledSelect } from './styles';

const Select = ({
  fullWidth,
  isLoading,
  className,
  isDisabled,
  placeholder,
  isMulti,
  value,
  isSearchable,
  options,
  onChange,
  noOptionsMessage,
  helperText,
  error,
  ...props
}) => (
  <>
    <StyledSelect
      className={className}
      classNamePrefix="rs"
      error={error}
      fullWidth={fullWidth}
      helperText={helperText}
      isDisabled={isDisabled}
      isLoading={isLoading}
      isMulti={isMulti}
      isSearchable={isSearchable}
      menuPlacement="auto"
      noOptionsMessage={() => noOptionsMessage}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      value={value}
      {...props}
    />
    {helperText ? (
      <StyledHelperText error={error}>{helperText}</StyledHelperText>
    ) : null}
  </>
);

Select.propTypes = {
  className: PropTypes.string,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isMulti: PropTypes.bool,
  isSearchable: PropTypes.bool,
  noOptionsMessage: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape(PropTypes.any)),
    PropTypes.shape(PropTypes.any),
    PropTypes.string,
    PropTypes.any,
  ]),
};

Select.defaultProps = {
  className: '',
  error: false,
  fullWidth: false,
  helperText: '',
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isSearchable: true,
  noOptionsMessage: 'No Options',
  onChange: () => {},
  options: [],
  placeholder: '',
  value: '',
};

export default Select;
